@if ('MOBILE_ONLY' !== type()) {
  <webmodule-order-panel (showContentChange)="showSelected.set($event)"
                         [canCollapse]="isLoaded()"
                         [showContent]="showSelected()">
    <ng-container heading>
      <h3 class="mb-0" [innerHTML]="index() + '. ' + ('block.internet.heading' | translate) "></h3>
    </ng-container>
    @if (isLoaded()) {
      <ng-container altContent>
        @if (select(); as selected) {
          <div class="grid grid-cols-2">
            <div class="h5 mb-0">{{ selected.name }}</div>
            @if (selected.priceAsNumber) {
              <div class="h5 mb-0 text-right row-span-2">{{ selected.priceAsNumber | currency:'EUR' }} per maand</div>
            }
            <div class="flex gap-4">
              <div class="flex items-center"><i-tabler class="h-4 w-4 mr-1" name="circle-arrow-down-filled"></i-tabler>
                {{ selected.download }} Mbit/s</div>
            <div class="flex items-center"><i-tabler class="h-4 w-4 mr-1" name="circle-arrow-up-filled"></i-tabler>
              {{ selected.upload }} Mbit/s</div>
        </div>
      </div>
        }
  </ng-container>
  }
  <ng-container content>

    @if (isLoaded()) {
      <div [innerHtml]="'block.internet.description' | translate" class="wysiwyg"></div>

      @if(hasTranslationForKey('block.internet.more-information')) {
        <div>
          <button (click)="openModal('block.internet.heading', 'block.internet.more-information')" class="btn link">{{ 'common.button.more-info' | translate }}</button>
        </div>
      }
    } @else {
      <webmodule-order-skeleton-screen [pulse]="isLoading()" type="TEXT_BLOCK" />
    }

    <fieldset>
      <legend class="sr-only">{{ 'block.internet.heading' | translate }}</legend>
      <div class="grid gap-4">
        @if (isLoaded()) {
          @if (internetTypeSelection) {
            <div class="grid grid-cols-2 gap-4">
              <button class="button primary outline"
                      [ngClass]="{'active': internetType() === 'all-in-one'}"
                      (click)="selectInternetType('all-in-one')">All in one</button>
              <button class="button primary outline"
                      [ngClass]="{'active': internetType() === 'internet-only'}"
                      (click)="selectInternetType('internet-only')">Internet only</button>
            </div>
          }
          @for (item of availablePackages(); track item) {
            <webmodule-order-input-panel (selected)="setSelected(item, 'internet'); showSelected.set(false)"
                                         [checked]="item === select()"
                                         [price]="item.priceAsNumber"
                                         [discount]="getDiscount(item.id, 0)"
                                         [ref]="item.id"
                                         groupName="internet">
              <ng-container label>{{ item.name }}</ng-container>
              <ng-container content>
                @if (item.download && item.upload) {
                  <span class="col-span-3 my-2 rounded-full h-2 bg-gradient-to-r from-green-200 to-orange-300 bg-green-300 overflow-hidden">
                    <div [style.width.%]="getBarSpeed(item.download)" class="ml-auto bg-gray-100 h-full"></div>
                  </span>

                  <div class="col-span-3 grid grid-cols-2">
                    <span class="text-sm text-gray-500 flex items-center"
                          id="internet-{{ item.id }}-download">
                      <i-tabler class="h-4 w-4 mr-1" name="circle-arrow-down-filled"></i-tabler>
                      {{ item.download }} Mbit/s download
                    </span>
                    <span class="text-sm text-gray-500 flex items-center"
                          id="internet-{{ item.id }}-upload">
                      <i-tabler class="h-4 w-4 mr-1" name="circle-arrow-up-filled"></i-tabler>
                      {{ item.upload }}  Mbit/s upload
                    </span>
                  </div>
                }
                @if (item.description) {
                  <span [innerHTML]="item.description"
                        class="mt-1 text-sm col-span-2 text-gray-500 whitespace-pre-line col-span-3"
                        id="internet-{{ item.id }}-description">
                  </span>
                }

                @if (hasPromotion(item.id); as promotion) {
                  <webmodule-order-alert [title]="promotion.name ?? ''"
                                         [showIcon]="false"
                                         class="my-4 col-span-3 " >
                    <div>
                      <div class="text-xs font-semibold"><em>Deze promotie is geldig van {{ promotion.startDate | date }}  tot {{ promotion.endDate | date }}</em></div>
                    </div>
                  </webmodule-order-alert>
                }
              </ng-container>
            </webmodule-order-input-panel>
          }
        } @else {
          <webmodule-order-skeleton-screen [pulse]="isLoading()" type="INPUT_PANEL"></webmodule-order-skeleton-screen>
          <webmodule-order-skeleton-screen [pulse]="isLoading()" type="INPUT_PANEL"></webmodule-order-skeleton-screen>
        }
      </div>
    </fieldset>
  </ng-container>
</webmodule-order-panel>
}
